<template>
  <v-layout align-center column style="margin-top:100px;">
    <p class="Section-Title">Liputan Media</p>
    <v-slide-group class="px-4">
      <v-slide-item v-for="(data, i) in mediaList" :key="i" class="text-wrap">
        <div
          class="Group-45"
          style="cursor: pointer;"
          @click="goToNews(data.link)"
        >
          <img v-bind:src="`${data.thumbnail}`" class="Liputan-Image" />
          <p class="title-media">
            {{ data.text }}
          </p>
          <img v-bind:src="data.logo" class="dailysocial_logo" />
        </div>
      </v-slide-item>
    </v-slide-group>
    <v-slide-group class="px-4">
      <v-slide-item v-for="(data, i) in mediaList2" :key="i" class="text-wrap">
        <div
          class="Group-45"
          style="cursor: pointer;"
          @click="goToNews(data.link)"
        >
          <img v-bind:src="`${data.thumbnail}`" class="Liputan-Image" />
          <p class="title-media">
            {{ data.text }}
          </p>
          <img v-bind:src="data.logo" class="dailysocial_logo" />
        </div>
      </v-slide-item>
    </v-slide-group>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      mediaList: [
        {
          thumbnail: require("../../assets/TentangKami/Liputan-Image-6.jpg"),
          text: `Sunu Widyatmoko – Co-Founder & CEO of Dompet Kilat (Enterprise Zone)`,
          logo: require("../../assets/TentangKami/ez-logo.jpg"),
          link:
            "https://enterprisezone.cc/sunu-widyatmoko-co-founder-ceo-of-dompet-kilat/",
        },
        {
          thumbnail: require("../../assets/TentangKami/Liputan-Image-5.jpg"),
          text: `SME lending during the pandemic: Is it sensible or unwise?
            (E27)`,
          logo: require("../../assets/TentangKami/e27-logo.png"),
          link:
            "https://e27.co/sme-lending-during-the-pandemic-is-it-sensible-or-unwise-20210802/",
        },
        {
          thumbnail: require("../../assets/TentangKami/Liputan-Image-1.png"),
          text: `Dompet Kilat rebrands, announces new service offerings (Digital News Asia)`,
          logo: require("../../assets/TentangKami/dna_logo.png"),
          link:
            "https://www.digitalnewsasia.com/business/dompet-kilat-rebrands-announces-new-service-offerings",
        },
        {
          thumbnail: require("../../assets/TentangKami/Liputan-Image-2.png"),
          text: `Dorong Perekonomian Indonesia, Dompet Kilat Hadirkan Tiga Layanan Terbaru (Berita Satu)`,
          logo: require("../../assets/TentangKami/beritasatu_logo.png"),
          link:
            "https://www.beritasatu.com/digital/760677/dorong-perekonomian-indonesia-dompet-kilat-hadirkan-tiga-layanan-terbaru",
        },
      ],
      mediaList2: [
        {
          thumbnail: require("../../assets/TentangKami/Liputan-Image-3.png"),
          text: `Dampak Pandemi Covid-19, Dompet Kilat: UMKM Butuh Dukungan Finansial (Tribunnews)`,
          logo: require("../../assets/TentangKami/tribun_logo.png"),
          link:
            "https://www.tribunnews.com/bisnis/2021/04/15/dampak-pandemi-covid-19-dompet-kilat-umkm-butuh-dukungan-finansial",
        },
        {
          thumbnail: require("../../assets/TentangKami/Liputan-Image-4.png"),
          text: `Dukung UMKM, Dompet Kilat Hadirkan Tiga Fitur Baru (Republika)`,
          logo: require("../../assets/TentangKami/republika_logo.png"),
          link:
            "https://www.republika.co.id/berita/qrlt5r456/dukung-umkm-daerah-emdompet-kilatem-hadirkan-tiga-fitur-baru",
        },
        {
          thumbnail: require("../../assets/TentangKami/liputan2/Liputan-Image.png"),
          text: `DompetKilat Secara Khusus Menargetkan Pengguna Dari Kalangan Bawah
            (Dailysocial)`,
          logo: require("../../assets/TentangKami/dailysocial-logo.png"),
          link: "https://dailysocial.id/post/fintech-lending-dompet-kilat",
        },
        {
          thumbnail: require("../../assets/TentangKami/liputan4/Liputan-Image.png"),
          text: `5 Tekfin Berizin OJK (Kompas)`,
          logo: require("../../assets/TentangKami/kompas-logo.png"),
          link:
            "https://www.kompas.id/baca/video/2019/05/18/5-tekfin-berizin-ojk/",
        },
      ],
    };
  },

  methods: {
    goToNews(url) {
      window.location = url;
    },
  },
};
</script>
<style scoped>
.Section-Title {
  width: 177px;
  height: 30px;
  flex-grow: 0;
  margin: 0px 151px 0px 150px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Group-45 {
  width: 208px;
  height: 244px;
  flex-grow: 0;
  margin: 49px 20px 0 0;
}
.title-media {
  width: 209px;
  height: 54px;
  flex-grow: 0;
  font-family: Sora;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.cnbc_logo {
  width: 28px;
  height: 28px;
  flex-grow: 0;
  object-fit: contain;
}
.dailysocial_logo {
  width: 77.6px;
  height: 28px;
  flex-grow: 0;
  object-fit: contain;
}
.warta_logo {
  width: 111px;
  height: 19px;
  flex-grow: 0;
  object-fit: contain;
  border-radius: 2px;
}
.kompas_logo {
  width: 104px;
  height: 21px;
  flex-grow: 0;
  object-fit: contain;
}
</style>
